import { siteApiSlice } from "../../app/siteApiSlice";

export interface SiteStatusRow {
	component: string;
	address: string;
	status: string;
	response: string;
	messages: string[];
}

export interface SiteStatusRows extends Array<SiteStatusRow> {}

export interface SiteStatus {
	summary: string;
	rows: SiteStatusRows;
}

export const statusApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		fetchStatus: build.query<SiteStatus, void>({
			query: () => `/status`,
		}),
	}),
});

export const { useFetchStatusQuery } = statusApiSlice;
